angular.module('unica_agenda.agenda_controllers')

.controller('AgendaCustomizeController',
	function(
		$rootScope, $scope, $state, $stateParams,
		$confirm,
		AgendaService,
		TASK_TYPES
	) {

	$scope.taskTypes = TASK_TYPES;

	$scope.event_id = $stateParams.event_id;
	$scope.stage_id = parseInt( $stateParams.stage_id );

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

	$scope.days = [];

	$scope.$on( 'stages_loaded', function() {

		angular.forEach( $rootScope.stages, function(st) {

			if ( st.id == $stateParams.stage_id ) {

				st['from_date'].setHours(0);
				st['to_date'].setHours(23);

				var fdM  = moment( st['from_date'], 'DD-MM-YYYY' ),
					tdM  = moment( st['to_date'],   'DD-MM-YYYY' ),
					diff = tdM.diff( fdM, 'days'),
					i    = 0;

				// Starting day
				$scope.days.push( fdM.format('DD/MM/YYYY') );

				for ( ; i < diff; i++ ) {
					$scope.days.push( fdM.add('days', 1).format('DD/MM/YYYY') );
				}

			}

		});

	});

	$rootScope.getAgenda( $stateParams.stage_id );

	$rootScope.getRelatorList();

	$rootScope.getWorkshopSessionByEvent( $stateParams.event_id );

	$scope.addTask = function() {
		$rootScope.agendaData.push({
			stage_id: $scope.stage_id,
			type: '',
			title: '',
			day: '',
			from_time: '',
			to_time: '',
		});
	};

	$scope.removeTask = function( index, taskId ) {

		if ( taskId ) {

			$confirm({
				title: 'Sei sicuro di voler eliminare il task?',
				text: 'Confermi?'
			}).then(function() {

				$scope.showLoader();
				AgendaService
					.delete( taskId )
					.then(function(data) {
						$scope.hideLoader();

						if (data) {
							$rootScope.agendaData.splice(index, 1);
						}
					});

			}, function() {
				// Cancel
			});

		} else {
			$rootScope.agendaData.splice(index, 1);
		}

	};


	function parseAgendaFromDateToTimestamp(agendaData) {
		angular.forEach(agendaData, function(task, key) {
			if ( task.type == 'speech' || task.type == 'meal' || task.type == 'workshop' ) {
				agendaData[key].from_time = moment( task.from_time ).format('HH:mm:ss');
				agendaData[key].to_time   = moment( task.to_time ).format('HH:mm:ss');
			} else {
				agendaData[key].from_time = null;
				agendaData[key].to_time   = null;
			}
		});
		return agendaData;
	};


	$scope.workshop_selection = function(index){
		var task = $rootScope.agendaData[index];
		$rootScope.workshopSessionList.forEach(function(ws) {
			if ( ws.id == task.workshop_session_id ){
				task.title     = ws.workshop.title;
				task.day       = moment( ws.from_date ).format('DD/MM/YYYY');
				task.from_time = ws.from_time;
				task.to_time   = ws.to_time;
			}
		});
	}

	
	$scope.saveAgenda = function() {
		$scope.showLoader();
		var agData = angular.copy($rootScope.agendaData);
		agData = parseAgendaFromDateToTimestamp(agData);

		AgendaService
			.save(agData, $rootScope.eventData.id, $scope.stage_id)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Agenda aggiornata con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});
